// @safetyhub/report-composer — 실폼 반응형 뷰 자동 판정 (Phase 4)
//
// 실제 작성 폼(web)에서 현재 뷰포트(폭·orientation)에 매칭되는 반응형 뷰 키를 판정한다.
// 저작(admin)은 뷰 스위처로 명시 지정하지만, 실폼은 사용자 기기/회전에 따라 자동 판정해야 하므로
// matchMedia로 레지스트리(COMPOSER_VIEWS) media를 평가한다.
// 결정: 2026-07-09-composer-responsive-view-overrides (Phase 4).

import { useEffect, useState } from 'react';
import { COMPOSER_BASE_VIEW_KEY, COMPOSER_VIEWS } from '@safetyhub/shared';

/**
 * 현재 뷰포트에 매칭되는 뷰 키 판정 — 레지스트리 순서대로 첫 매칭.
 * media 없거나 아무것도 안 맞으면 base. SSR/matchMedia 부재 시 base(폴백).
 * media에 orientation을 포함한 뷰(예: 폴드형-가로)도 그대로 지원한다.
 */
export function detectActiveComposerView(): string {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return COMPOSER_BASE_VIEW_KEY;
  }
  for (const v of COMPOSER_VIEWS) {
    if (v.media && window.matchMedia(v.media).matches) return v.key;
  }
  return COMPOSER_BASE_VIEW_KEY;
}

/**
 * 실폼에서 현재 뷰포트에 맞는 반응형 뷰 키를 반환. 리사이즈/회전 시 matchMedia change로 재판정.
 * 레지스트리에 뷰(플립 등)를 추가하면 자동으로 이 훅이 그 media도 평가(확장 가능).
 */
export function useActiveComposerView(): string {
  const [view, setView] = useState<string>(detectActiveComposerView);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mqls = COMPOSER_VIEWS.filter((v) => v.media).map((v) => window.matchMedia(v.media as string));
    const onChange = () => setView(detectActiveComposerView());
    mqls.forEach((m) => m.addEventListener('change', onChange));
    onChange(); // mount 후 초기 동기화(hydration 안전)
    return () => mqls.forEach((m) => m.removeEventListener('change', onChange));
  }, []);
  return view;
}
